namespace Serenity {

    @Serenity.Decorators.registerEditor("Serenity.FileUploadEditor")
    export class CustomFileUpload extends Serenity.FileUploadEditor {
        public done = (res) => {

        }
        constructor(div: JQuery, opt: Serenity.FileUploadEditorOptions) {
            super(div, opt);
            var uio = this.getUploadInputOptions();
            uio.fileDone = (response, name, data) => {
                if (!Serenity.UploadHelper.checkImageConstraints(response, this.options)) {
                        return;
                    }

                var newEntity: Serenity.UploadedFile = {
                        OriginalName: name,
                        Filename: response.TemporaryFile
                    };

                    this.entity = newEntity;
                    this.populate();
                    this.updateInterface();
                    
                    var validator = this.hiddenInput.closest('form').data('validator');
                    if (validator != null) {
                        validator.element(this.hiddenInput);
                }
                this.done(newEntity);
            }
            this.uploadInput = Serenity.UploadHelper.addUploadInput(uio);
        }
    }
}